import React from "react";

const Customform = ({
  fields,
  onSubmit,
  mode,
  handleCustomerImageChange,
  imagePreview,
}) => {
  const [formData, setFormData] = React.useState({});

  const handleChange = (e, field) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    }else if (type === "file" && handleCustomerImageChange) {
        handleCustomerImageChange(e); 
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="custom-form">
      {fields.map((field) => (
        <div key={field.name} className="form-group">
          <label>{field.label}</label>

          {field.type === "select" ? (
            <select
              name={field.name}
              required={field.required}
              onChange={(e) => handleChange(e, field)}
              className="form-control"
            >
              <option value="">Select {field.label}</option>
              {field.options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          ) : field.type === "file" ? (
            <>
              <input
                type="file"
                name={field.name}
                accept="image/*"
                onChange={(e) => handleChange(e, field)}
                required={mode === "ADD"}
                className="form-control"
              />
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="h-20 w-20 object-cover mt-2 rounded"
                />
              )}
            </>
          ) : (
            <input
              type={field.type || "text"}
              name={field.name}
              placeholder={field.placeholder}
              required={field.required}
              onChange={(e) => handleChange(e, field)}
              className="form-control"
            />
          )}
        </div>
      ))}

      <button type="submit" className="submit-btn">
        {mode === "ADD" ? "Add Offer" : "Update Offer"}
      </button>
    </form>
  );
};

export default Customform;
